import { useEffect, useState } from "react"
import { Modal } from "../../components/common/Modal/Modal"
import { ModalBody } from "../../components/common/Modal/ModalBody"
import { Typography, Grid, Button, CircularProgress } from "@mui/material"
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ApiStatus } from "../../types/api/status"
import Radio from '@mui/material/Radio';
import { useDETStore } from "../../hooks/useDETStore";
import { useMechanicStore } from "../../hooks/useMechanicStore";
import { useNotificationStore } from "../../hooks/useNotificationStore";
import { createNotification } from "../../types/slices/notificationType";

export const DETModalValidate: React.FC<any> = (props): JSX.Element | any => {
    const { open, closeModal, onList, rowSelected } = props

    const { status, validateDET } = useDETStore()
    const { mechanics, getMechanics } = useMechanicStore()
    const { createNotifications } = useNotificationStore()

    const [statusValidate, setStatusValidate] = useState<number>(1)

    useEffect(() => {
        dataApi()
    }, [])

    const dataApi = async () => {
        await getMechanics()
    }

    const handleSubmit = async () => {
        const response = await validateDET(rowSelected.id, statusValidate)
        if (response === true) {
            mechanics?.map(async (element) => {
                const notify: createNotification = {
                    iduser_type: 6,
                    idreceiver: element.id_user,
                    rut_receiver: element.rut,
                    title: "Documento DET validado",
                    details: 'Se ha validado un documento DET.',
                    idview: 7,
                    idcompany: 1,
                    idregister: rowSelected.id,
                }
                return await createNotifications(notify)
            })
            onList()
            closeModal()
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick size="xs">
            <ModalBody>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography sx={{ fontWeight: 'bolder' }}>
                        VALIDAR DET
                    </Typography>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        <FormGroup row={true}>
                            <FormControlLabel control={<Radio checked={statusValidate === 1} onClick={(e) => setStatusValidate(1)} />} label="Aprobar" />
                            <FormControlLabel control={<Radio checked={statusValidate === 2} onClick={(e) => setStatusValidate(2)} />} label="Rechazar" />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        <Button
                            onClick={() => handleSubmit()}
                            sx={{ backgroundColor: '#73B2FF', color: '#fff', float: 'right', height: '25px', margin: '0px 5px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#73B2FF" } }}
                        >
                            {
                                status === ApiStatus.FETCHING
                                    ?
                                    <CircularProgress color="inherit" size={20} sx={{ color: '#fff', marginRight: "10px" }} />
                                    :
                                    'Confirmar'
                            }
                        </Button>
                        <Button
                            disabled={status === ApiStatus.FETCHING}
                            onClick={() => closeModal()}
                            sx={{ backgroundColor: '#73B2FF', color: '#fff', float: 'right', height: '25px', margin: '0px 5px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#73B2FF" } }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBody>
        </Modal>
    )
}